import { Box, styled } from '@material-ui/core';
import React, { CSSProperties } from 'react';
import { StringKey } from '../../../../../../Locales/fr';
import { FormattedMessage } from 'react-intl';

type WidgetProps = { labelId: StringKey; styles?: { root?: CSSProperties, label?: CSSProperties } };
export const LcdWidget = ({ labelId, styles, children }: React.PropsWithChildren<WidgetProps>) => {
    return (
        <Container id={labelId} style={styles?.root}>
            <Title style={styles?.label}>
                <FormattedMessage id={labelId} />
            </Title>
            {children}
        </Container>
    );
};

const Container = styled(Box)({
    flex: 1,
    height: 42,
    background: '#FFFFFF',
    borderRadius: 8,
    padding: '0px 2px 0px 18px',
    display: 'flex',
    alignItems: 'center',
    gap: 16,
});

const Title = styled(Box)({
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '22px',
    color: '#000000',
    textTransform: 'uppercase',
});

export type WithFocusProps = { focused?: boolean } & React.SVGAttributes<SVGElement>;
export const IconExpandPlanBande = ({ focused, ...attrs }: WithFocusProps) => {
    return (
        <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            pointerEvents="none"
            {...attrs}>
            <g filter="url(#filter0_d_6511_21383)">
                <circle cx="16.857" cy="17" r="12" fill={focused ? '#13123A' : '#fff'} />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.2 16.456a.543.543 0 1 0 1.085 0v-4.343c0-.3-.243-.543-.543-.543H17.4a.543.543 0 1 0 0 1.086h3.8zm-8.686 1.086a.543.543 0 1 0-1.086 0v4.343c0 .3.243.542.543.542h4.343a.543.543 0 1 0 0-1.085h-3.8z"
                fill={focused ? '#fff' : '#13123A'}
            />
            <defs>
                <filter
                    id="filter0_d_6511_21383"
                    x=".557"
                    y=".7"
                    width="32.6"
                    height="32.6"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="2.15" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_6511_21383" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_6511_21383" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};
